import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['checkbox'];

  update() {
    const payload = `${this.checkboxTarget.dataset.model}[${this.checkboxTarget.dataset.attribute}]=${this.checkboxTarget.checked}`;

    // Rails is available globally from sprockets
    Rails.ajax({
      type: 'put',
      url: this.checkboxTarget.dataset.url,
      data: payload,
    });
  }
}
